import { AxiosResponse } from 'axios';
import { endPoints } from '../../utils/apiEndpoints';
import axios from '../../redux/axiosInterceptor'

export function requestSavePanImage(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.uploadPanImage,
    data,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function requestSubmitPanNumber(data: any) : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.submitPanNumber,
    data,
  });
}

export function requestConfirmPan() : Promise<AxiosResponse> {
  return axios.request({
    method: 'post',
    baseURL: endPoints.base,
    url: endPoints.confirmPan,
  });
}
